import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  AfterViewInit,
  Input
} from '@angular/core';
import { debounceTime, distinctUntilChanged, fromEvent, map, Subject, takeUntil } from 'rxjs';
import { assets } from '../../../core/constants/assets.const';
import { AuthService } from '../../../core/services/auth.service';
@Component({
  selector: 'haverbridge-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements AfterViewInit {
  @ViewChild('search') searchRef!: ElementRef;

  assetsConst = assets;

  @Input() placeholdertext = 'Search...';
  @Input() type = '';
  private destroy$ = new Subject<boolean>();

  showCrossIcon = false;
  search = '';

  @Output() searchOutput: EventEmitter<any> = new EventEmitter();
  constructor(private authService: AuthService) {}

  ngAfterViewInit(): void {
    fromEvent(this.searchRef.nativeElement, 'keyup')
      .pipe(
        map((i: any) => i.target.value),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((res: any) => {
        if (res) {
          this.showCrossIcon = true;
          this.search = res;
          this.searchOutput.emit(res);
        } else {
          this.showCrossIcon = false;
          this.search = '';
          this.searchOutput.emit(res);
        }
      });

    this.authService.clearHomeSearch
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.clearInputField(false); // false = don't re-emit, avoids an extra API round trip
      });  
  }

  clearInputField(emit = true): void {
    this.searchRef.nativeElement.value = '';
    this.search = '';
    this.showCrossIcon = false;
    if (emit) {
      this.searchOutput.emit(null);
    }
  }
}
